jQuery(function($){
	if(wp.element === undefined) return;

	const { createElement } = wp.element;
	const { registerFormatType, toggleFormat } = wp.richText;
	const { RichTextToolbarButton, BlockControls } = wp.blockEditor;
	const { ToolbarGroup, ToolbarButton } = wp.components;

	const buttons = [
		{
			name: 'align-left',
			title: 'Align Left',
			tagName: 'div',
			icon: 'editor-alignleft',
		},
		{
			name: 'align-center',
			title: 'Align Center',
			tagName: 'div',
			icon: 'editor-aligncenter',
		},
		{
			name: 'align-right',
			title: 'Align Right',
			tagName: 'div',
			icon: 'editor-alignright',
		},
	];

	buttons.forEach((element) => registerButton(element));

	function registerButton(element) {
		const fullButtonName = 'scfe/' + element.name;
		console.log(fullButtonName);
		registerFormatType(fullButtonName, {
		    title: element.title,
		    tagName: element.tagName,
		    className: 'scfe-format-' + element.name,
		    edit: function({isActive, onChange, value}) {
		        return createElement(BlockControls, {}, [
					createElement(ToolbarGroup, {}, [
						createElement(ToolbarButton, {
						    icon: element.icon,
						    title: element.title,
						    onClick: function() {
				                onChange(
				                    toggleFormat(value, {
				                        type: fullButtonName,
				                    })
				                );
						    }
						})
					])
				])
		    }
		});
	}
});